var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-screen',{staticClass:"screen-rules",attrs:{"title":"Privacy","back":(_vm.loggedin) ? false : 'Login',"textOnly":true,"menu":_vm.loggedin}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.texts.privacy)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }